import React, { useState } from 'react';
import Icon from '../../components/AppIcon';

const ACCENT = '#D6EF4E';

export default function LectorPrecios() {
  const [query, setQuery] = useState('');
  const [searchType, setSearchType] = useState('nombre');
  const [result, setResult] = useState(null);
  const [searching, setSearching] = useState(false);
  const [history, setHistory] = useState([]);

  const handleSearch = () => {
    if (!query?.trim()) return;
    setSearching(true);
    setHistory(prev => [{ query, type: searchType, date: new Date()?.toLocaleTimeString() }, ...prev?.slice(0, 9)]);
    setTimeout(() => {
      setResult(null);
      setSearching(false);
    }, 700);
  };

  return (
    <div className="min-h-screen px-4 py-6 md:px-8" style={{ background: 'linear-gradient(135deg, #0A0A0A 0%, #111111 50%, #0D0D0D 100%)' }}>
      {/* Breadcrumb */}
      <div className="flex items-center gap-2 mb-5 font-oranienbaum text-white/30" style={{ fontSize: 'var(--fs-sm)' }}>
        <Icon name="Home" size={13} />
        <span>/</span>
        <span className="text-[#D6EF4E]/60">Inventario</span>
        <span>/</span>
        <span className="text-white/50">Lector de Precios</span>
      </div>
      {/* Header */}
      <div className="flex items-center gap-3 mb-6">
        <div className="w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0"
          style={{ background: 'rgba(214,239,78,0.10)', border: '1px solid rgba(214,239,78,0.25)' }}>
          <Icon name="Search" size={22} className="text-[#D6EF4E]" />
        </div>
        <div>
          <h1 className="font-oranienbaum font-bold text-white tracking-wide" style={{ fontSize: 'var(--fs-page-title)' }}>🔍 Lector de Precios</h1>
          <p className="font-oranienbaum text-white/40" style={{ fontSize: 'var(--fs-sm)' }}>Consulta rápida por EAN, PLU, código interno o nombre</p>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Search panel */}
        <div className="lg:col-span-2 space-y-5">
          <div className="rounded-2xl p-5" style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.07)' }}>
            <div className="flex flex-wrap gap-2 mb-4">
              {[
                { id: 'ean', label: 'EAN / Código de barras', icon: 'Barcode' },
                { id: 'plu', label: 'PLU', icon: 'Hash' },
                { id: 'codigo', label: 'Código Interno', icon: 'Tag' },
                { id: 'nombre', label: 'Nombre', icon: 'Type' },
              ]?.map(t => (
                <button key={t?.id} onClick={() => setSearchType(t?.id)}
                  className="flex items-center gap-1.5 px-3 py-2 rounded-xl font-oranienbaum transition-all"
                  style={{
                    background: searchType === t?.id ? `${ACCENT}15` : 'rgba(255,255,255,0.04)',
                    border: `1px solid ${searchType === t?.id ? `${ACCENT}35` : 'rgba(255,255,255,0.08)'}`,
                    color: searchType === t?.id ? ACCENT : 'rgba(255,255,255,0.55)',
                    fontSize: 'var(--fs-sm)',
                  }}>
                  <Icon name={t?.icon} size={13} />
                  {t?.label}
                </button>
              ))}
            </div>
            <div className="flex gap-3">
              <div className="flex items-center gap-3 flex-1 rounded-xl px-4 border" style={{ background: 'rgba(255,255,255,0.04)', borderColor: 'rgba(255,255,255,0.12)', minHeight: 'var(--control-height-lg)' }}>
                <Icon name="Search" size={18} className="text-white/35" />
                <input value={query} onChange={e => setQuery(e?.target?.value)} onKeyDown={e => e?.key === 'Enter' && handleSearch()}
                  placeholder={searchType === 'ean' ? 'Escanear o introducir EAN...' : searchType === 'plu' ? 'Introducir PLU...' : searchType === 'codigo' ? 'Código interno...' : 'Nombre del producto...'}
                  className="flex-1 bg-transparent outline-none font-oranienbaum text-white placeholder-white/25"
                  style={{ fontSize: 'var(--fs-lg)' }} />
              </div>
              <button onClick={handleSearch} disabled={searching}
                className="flex items-center gap-2 px-6 rounded-xl font-oranienbaum font-bold transition-all"
                style={{ background: ACCENT, color: '#000', fontSize: 'var(--fs-btn)', minHeight: 'var(--control-height-lg)' }}>
                {searching ? <div className="w-5 h-5 rounded-full border-2 border-black/20 border-t-black animate-spin" /> : <Icon name="Search" size={18} />}
                Buscar
              </button>
            </div>
          </div>

          {/* Result */}
          {searching && (
            <div className="rounded-2xl p-8 flex items-center justify-center gap-3" style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.07)' }}>
              <div className="w-6 h-6 rounded-full border-2 border-white/10 border-t-[#D6EF4E] animate-spin" />
              <span className="font-oranienbaum text-white/50" style={{ fontSize: 'var(--fs-base)' }}>Buscando...</span>
            </div>
          )}

          {!searching && result === null && query && (
            <div className="rounded-2xl p-8 flex flex-col items-center gap-4" style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.07)' }}>
              <div className="w-14 h-14 rounded-2xl flex items-center justify-center" style={{ background: 'rgba(214,239,78,0.06)', border: '1px solid rgba(214,239,78,0.15)' }}>
                <Icon name="Database" size={24} className="text-[#D6EF4E]/40" />
              </div>
              <div className="text-center">
                <p className="font-oranienbaum font-bold text-white/60" style={{ fontSize: 'var(--fs-lg)' }}>Pendiente de conexión con Supabase</p>
                <p className="font-oranienbaum text-white/30 mt-2 max-w-md" style={{ fontSize: 'var(--fs-sm)' }}>
                  Una vez conectado, mostrará: coste real, PVP físico, PVP online, margen, stock, lote, caducidad, ubicación, última compra y última venta.
                </p>
              </div>
            </div>
          )}

          {!searching && !query && (
            <div className="rounded-2xl p-8 flex flex-col items-center gap-4" style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.07)' }}>
              <Icon name="Search" size={36} className="text-white/15" />
              <p className="font-oranienbaum text-white/35 text-center" style={{ fontSize: 'var(--fs-base)' }}>Introduce un EAN, PLU, código o nombre para consultar el precio y datos del producto</p>
            </div>
          )}

          {/* Product detail placeholder */}
          <div className="rounded-2xl p-5" style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.07)' }}>
            <h3 className="font-oranienbaum font-bold text-white mb-4" style={{ fontSize: 'var(--fs-section-title)' }}>Datos del Producto</h3>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
              {[
                { label: 'Coste Real', icon: 'TrendingDown', color: '#F87171' },
                { label: 'PVP Físico', icon: 'Store', color: ACCENT },
                { label: 'PVP Online', icon: 'Globe', color: '#60A5FA' },
                { label: 'Margen', icon: 'Percent', color: '#34D399' },
                { label: 'Stock', icon: 'Package', color: '#FBBF24' },
                { label: 'Lote', icon: 'Hash', color: '#A78BFA' },
                { label: 'Caducidad', icon: 'Calendar', color: '#F97316' },
                { label: 'Ubicación', icon: 'MapPin', color: '#60A5FA' },
                { label: 'Última Compra', icon: 'ShoppingCart', color: '#34D399' },
                { label: 'Última Venta', icon: 'TrendingUp', color: ACCENT },
              ]?.map((item, i) => (
                <div key={i} className="rounded-xl p-3 flex items-center gap-2" style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)' }}>
                  <Icon name={item?.icon} size={14} style={{ color: item?.color }} />
                  <div>
                    <p className="font-oranienbaum text-white/35" style={{ fontSize: 'var(--fs-xs)' }}>{item?.label}</p>
                    <p className="font-oranienbaum text-white/50 font-medium" style={{ fontSize: 'var(--fs-sm)' }}>—</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Quick actions */}
          <div className="rounded-2xl p-5" style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.07)' }}>
            <h3 className="font-oranienbaum font-bold text-white mb-3" style={{ fontSize: 'var(--fs-section-title)' }}>Acciones Rápidas</h3>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
              {[
                { label: 'Editar precio', icon: 'Edit2', color: ACCENT },
                { label: 'Recalcular precio', icon: 'RefreshCw', color: '#60A5FA' },
                { label: 'Imprimir etiqueta', icon: 'Printer', color: '#34D399' },
                { label: 'Enviar a báscula EPelsa', icon: 'Scale', color: '#FBBF24' },
                { label: 'Sincronizar tienda online', icon: 'Globe', color: '#A78BFA' },
                { label: 'Consultar historial', icon: 'History', color: '#F97316' },
              ]?.map((action, i) => (
                <button key={i} className="flex items-center gap-2 px-3 py-3 rounded-xl font-oranienbaum transition-all text-left hover:bg-white/5"
                  style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.07)', fontSize: 'var(--fs-sm)' }}>
                  <Icon name={action?.icon} size={15} style={{ color: action?.color }} />
                  <span className="text-white/60">{action?.label}</span>
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Sidebar: history */}
        <div className="space-y-4">
          <div className="rounded-2xl p-4" style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.07)' }}>
            <h3 className="font-oranienbaum font-bold text-white mb-3" style={{ fontSize: 'var(--fs-section-title)' }}>Historial de Consultas</h3>
            {history?.length === 0 ? (
              <p className="font-oranienbaum text-white/30 text-center py-6" style={{ fontSize: 'var(--fs-sm)' }}>Sin consultas recientes</p>
            ) : (
              <div className="space-y-2">
                {history?.map((h, i) => (
                  <button key={i} onClick={() => { setQuery(h?.query); setSearchType(h?.type); }}
                    className="w-full flex items-center gap-2 p-2.5 rounded-xl text-left hover:bg-white/5 transition-all"
                    style={{ border: '1px solid rgba(255,255,255,0.05)' }}>
                    <Icon name="Clock" size={13} className="text-white/25 flex-shrink-0" />
                    <div className="flex-1 min-w-0">
                      <p className="font-oranienbaum text-white/60 truncate" style={{ fontSize: 'var(--fs-sm)' }}>{h?.query}</p>
                      <p className="font-oranienbaum text-white/25" style={{ fontSize: 'var(--fs-xs)' }}>{h?.type} · {h?.date}</p>
                    </div>
                  </button>
                ))}
              </div>
            )}
          </div>

          {/* Audit trail */}
          <div className="rounded-2xl p-4" style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.07)' }}>
            <h3 className="font-oranienbaum font-bold text-white mb-3" style={{ fontSize: 'var(--fs-section-title)' }}>Auditoría de Precios</h3>
            <p className="font-oranienbaum text-white/30 text-center py-4" style={{ fontSize: 'var(--fs-sm)' }}>Pendiente de conexión con Supabase</p>
            <div className="space-y-2">
              {['Modificación de precio', 'Recálculo automático', 'Sincronización online']?.map((action, i) => (
                <div key={i} className="flex items-center gap-2 p-2 rounded-lg" style={{ background: 'rgba(255,255,255,0.02)' }}>
                  <Icon name="Shield" size={12} className="text-white/20" />
                  <span className="font-oranienbaum text-white/30" style={{ fontSize: 'var(--fs-xs)' }}>{action}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
